/**
 * Display form of a member identifier: the complete 11-digit zero-padded Alignment member ID.
 * member_id stays the stripped internal join key everywhere; this is applied only where an
 * identifier is shown to a user. Non-numeric / over-width passes through (fail-soft). Mirror of
 * the API copy and the portal's formatter.
 */
export function fmtMemberId(id: string | number | null | undefined): string {
  const s = String(id ?? '').trim();
  if (!/^\d{1,11}$/.test(s)) return s;
  return s.padStart(11, '0');
}
